

















































import Vue from 'vue';
import { Component, Prop } from "vue-property-decorator";
import HeaderComponents from "./../../../../../Assets/Card/Header/Header.vue";
import BodyComponents from "./../../../../../Assets/Card/Body/Body.vue";
import FooterComponents from "./../../../../../Assets/Card/Footer/Footer.vue";
import Axios from 'axios';
import { http } from '@/shared/https';
/**
 * Component's properties and events
 */
@Component({
    components: {
        HeaderComponents,
        BodyComponents,
        FooterComponents
    }
})
export default class PermissionFormComponent extends Vue {

    data() {
        return this.$store.state.permissionFormIndex;
    }

    //#. The beforeCreate() hook observes data and initialization events in your component.
    beforeCreate() {
    }

    //#. The created() hook is invoked when Vue has set up events and data observation.
    created() {
    }

    //#. The beforeMount() method is invoked after our template has been compiled and our virtual DOM updated by Vue.
    beforeMount() {
    }

    //#. The mounted() method gives you access to templates and enables interaction with the DOM.
    mounted() {
        var rolemenumasterid = parseInt(this.$store.state.permissionFormIndex.editedItem.RoleMenuMasterId == undefined ? this.$store.state.componentId : this.$store.state.permissionFormIndex.editedItem.RoleMenuMasterId);
        this.$store.state.permissionFormIndex.componentKeyId = rolemenumasterid;
        this.$store.state.permissionFormIndex.rolemenuheaders = [
            {
                text: 'MenuConfigId',
                // align: 'start',
                sortable: false,
                value: 'MenuConfigId',
                hide: true,
                align: ' d-none'
            },
            { text: 'MenuName', value: 'MenuName', hide: false },
            { text: 'View', value: 'View', hide: false },
            { text: 'Add', value: 'Add', hide: false },
            { text: 'Modify', value: 'Modify', hide: false },
            { text: 'Delete', value: 'Delete', hide: false },
            { text: 'RestrictedView', value: 'iron', hide: false },
            { text: 'Import', value: 'Import', hide: false },
            { text: 'Export', value: 'Export', hide: false },
            { text: 'BulkUpdate', value: 'BulkUpdate', hide: false },
            { text: 'BulkDelete', value: 'BulkDelete', hide: false },
            { text: 'Special1', value: 'Special1', hide: false },
            { text: 'Special2', value: 'Special2', hide: false },
            { text: 'Special3', value: 'Special3', hide: false },
            { text: 'Special4', value: 'Special4', hide: false },
            { text: 'Special5', value: 'Special5', hide: false },
        ];

        return http.get("/api/RoleMenuMapping/List/" + rolemenumasterid + "/null").then(record => {
            try {
                this.$store.state.permissionFormIndex.menus = record.data.Records;
            } catch (error) {
                // this._appErrorLog({ error: 'app > _getModuleGroup > ' + error.message });
            }
        }).catch(error => {
            //this._appErrorLog({ error: context.actions.list + ' > ' + error.message });
        });

        this.$store.state.permissionFormIndex.selected = [];
        this.$store.state.permissionFormIndex.selectAll = false;
    }

    // #. The beforeUpdate hook runs after data changes on your component and the update cycle begins, right before the DOM is patched and re- rendered.
    beforeUpdate() {
    }

    // #. The updated hook runs after data changes on your component and the DOM re-renders
    updated() {
    }

    // #. beforeDestroy is fired right before teardown. Your component will still be fully present and functional.
    beforeDestroy() {
    }

    // #. By the time you reach the destroyed hook, there�s pretty much nothing left on your component
    destroyed() {
    }
    select(item) {
        var itemval = 0;
        // item = (item == true ? 1 : (item == null ? 0 : 0));
        if (item == true)
            itemval = 1;
        else if (item == null)
            itemval = 0;
        else
            itemval = 0;
        return itemval;

    }
    savePermission() {
        let dashboard = this.$store.state.dashboard;
        this.$store.state.permissionFormIndex.selected = [];
        var selectedmenus = this.$store.state.permissionFormIndex.menus;
        var postdata = {
            roleMenu: selectedmenus
        };
        return http.post('/api/RoleMenuMapping/SavePermission/?roleMenuMasterId='
            + this.$store.state.permissionFormIndex.componentKeyId, selectedmenus, 'application/json')
            .then(record => {
                if (record.data.Result == 'OK') {
                    dashboard.color = "success";
                    dashboard.text = record.data.Message;
                    dashboard.snackbar = true;
                } else {
                    dashboard.color = "error";
                    dashboard.text = record.data.Message;
                    dashboard.snackbar = true;
                };

            })
            .catch(function () {
                console.log('FAILURE!!');
            });

    }

    toggleAll() {
        if (this.$store.state.permissionFormIndex.length)
            this.$store.state.permissionFormIndex.selected = [];
        else
            this.$store.state.permissionFormIndex.selected = this.$store.state.permissionFormIndex.items.slice();
    }

    cancelSelect() {
        //let context = this.$store.state;
        ////#.Remove form edit are triggered with the store.dispatch method.
        //this.$store.dispatch('dashboard/removeEdit', { context: context, self: this });
        ////#.formCancel event raising methods
        //this.$store.dispatch(context.fileName + '/formCancel', context);
    }
};
